import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AddSectionPage } from './add-section.page';

const routes: Routes = [
  {
    path: '',
    component: AddSectionPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AddSectionPageRoutingModule {}
